export default function(value) {
	if (value) {
		let pisPasep = (value + '').toString().replace(/\D/gi, '');
		let peso = '3298765432';
		let resto;
		let soma = 0;
		let vRet = false;

		// completa com zeros a esquerda
		if (pisPasep.length < 11) {
			for (let i = 1; i <= 11; i++) {
				if (pisPasep.length < 11) {
					pisPasep = '0' + pisPasep;
				}
			}
		}

		if (parseInt(pisPasep, 10) !== 0) {
			for (let j = 1; j < 11; j++) {
				soma = soma + parseInt(pisPasep.substring(j - 1, j), 10) * parseInt(peso.substring(j - 1, j), 10);
			}

			resto = 11 - (soma % 11);

			if (resto === 10 || resto === 11) {
				resto = 0;
			}

			if (resto === parseInt(pisPasep.substring(10, 11), 10)) {
				vRet = true;
			}
		}

		return vRet;
	} else {
		return true;
	}
}